import { render, staticRenderFns } from "./appstream.vue?vue&type=template&id=78a958df"
import script from "./appstream.vue?vue&type=script&lang=js"
export * from "./appstream.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports